// extracted by mini-css-extract-plugin
module.exports = {"tabList":"Tab_tabList__29sgx"};